/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Row, Col, Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Fetch, catchError } from '../../../utils/fetch'
import { connect } from 'react-redux'
import { loadingAction } from '../../../redux/actions';
import { AlertConfirm } from '../../../components/alert'
import { formatDate } from '../../../utils/formatDate';
import DataGridForm from '../../../components/common/DataGridForm';
import { copyToClickBoard } from '../../../utils/slug';
function ListarPaginas({ isLoadingAction }) {
    const [paginas, setPaginas] = React.useState(null)

    React.useEffect(() => {
        getPaginas()
    }, [])

    const getPaginas = async () => {
        isLoadingAction(true)
        try {
            const { data } = await Fetch('paginas?_eliminado=false&_sort=orden:ASC', 'get')
            setPaginas(data)
            isLoadingAction(false)
        } catch (error) {
            isLoadingAction(false)
            catchError(error);
        }
    }    


    const ordenContenido = async (e) => {

        try {
            isLoadingAction(true)

            let request = []
            e.forEach(async (item, indice) => {
                const params = {
                    orden: indice
                }
                request.push(Fetch('paginas/' + item.id, 'put', params))
            })

            Promise.all(request).then(response => { isLoadingAction(false) })

        } catch (error) {
            isLoadingAction(false)
            catchError(error);
        }
    }

    const deleteContenido = async (id) => {
        isLoadingAction(true)
        try {
            const params = {
                eliminado: true
            }
            await Fetch('paginas/' + id, 'put', params)
            getPaginas()
            isLoadingAction(false)
        } catch (error) {
            console.error('mostrando error', error)
            isLoadingAction(false)
            catchError(error);
        }
    }

    function RenderAlert(title, id) {
        AlertConfirm(title, 'Para eliminarlo definitivamente o recuperarlo deberás ir a la sección "Por eliminar".','question', (response) => {
            if (response.isConfirmed) {
                deleteContenido(id)
            }
        })
    }

    const onReorder = async (e) => {
        const visibleRows = e.component.getVisibleRows();
        const newData = [...paginas];
        const toIndex = newData.indexOf(visibleRows[e.toIndex].data);
        const fromIndex = newData.indexOf(e.itemData);

        newData.splice(fromIndex, 1);
        newData.splice(toIndex, 0, e.itemData);

        setPaginas(newData);
        await ordenContenido(newData)
    }

    function FActualizacion(data) {
        return formatDate(data?.updated_at)
    }
   
    function Plantilla(data) {
        return (
            <>
                {data.template == 'template1' && 'Plantilla 1'}
                {data.template == 'template2' && 'Plantilla 2'}
                {data.template == 'template3' && 'Plantilla 3'}
                {data.template == 'template4' && 'Plantilla 4'}</>
        )
    }

    function Slug(data) {
        return (
            <>
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip id={`tooltip-top`}>
                            Hacer click para copiar url
                        </Tooltip>
                    }
                >
                    <i className='fa fa-copy fa-lg text-info' role="button"
                        onClick={() => copyToClickBoard(data.slug)}
                    ></i>
                </OverlayTrigger>
            </>
        )
    }    

    function Accion(data) {
        return (
            <>
                <Link to={"/pages/ver/" + data.template + "/" + data.id} className="btn btn-sm btn btn-success"><i className="fa fa-pencil" /></Link>{' '}
                <a href={`${process.env.REACT_APP_BASE_URL_HOME}/pages-preview/${data.slug}`} target="_blank" className="btn btn-sm btn btn-info"><i className="fa fa-eye" /></a>{' '}
                <button type="button" className="btn btn-sm btn btn-danger" onClick={() => { RenderAlert("Está apunto de eliminar este contenido", data.id) }} ><i className="fa fa-trash" /></button>{' '}
            </>
        )
    }

    const creacion=(data)=>formatDate(data?.created_at);


    return (
        <React.Fragment>
            <Row>
                <Col md="12">
                    <Card>
                        <Card.Header>
                            <div className="float-right mt-10">
                                <Link to="/pages/nuevo" className="btn btn-primary btn-rounded box-shadow btn-icon"><i className="fa fa-plus" /> Nueva Página</Link>
                            </div>
                            Listado de páginas publicadas
                        </Card.Header>
                        <Card.Body>

                            <DataGridForm dataSource={paginas}
                                keyExpr='id'
                                allowReordering={true}
                                onReorder={onReorder}
                                columnHidingEnabled={true}
                                columns={[
                                    { caption: 'Id', dataField: 'id' },
                                    { caption: 'Nombre', dataField: 'nombre' },
                                    { caption: 'Url', alignment: 'center', width:50, render: 'Slug', cellRender: { Slug } },
                                    { caption: 'Plantilla', render: 'Plantilla', cellRender: { Plantilla } },
                                    { caption: 'Creado por', dataField: 'creado_por.username' },
                                    { caption: 'Creación',render:"creacion", cellRender:{creacion}},
                                    { caption: 'Actualizado por', dataField: 'actualizado_por.username' },
                                    { caption: 'Ult. Actualización', render: 'FActualizacion', cellRender: { FActualizacion } },                                    
                                    { caption: 'Acción', alignment: 'center', render: 'Accion', cellRender: { Accion } }
                                ]} />
                           
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {

    return {
        isLoading: state.loading,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        isLoadingAction: (data) => { dispatch(loadingAction(data)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ListarPaginas);